/* eslint-disable no-useless-concat */
import GKCharts from "components/GKCharts";

interface PieChartProps {
  data: any;
  pieClickData?: any;
  title?: string;
  onClick?: (clickedElement: any) => void;
  onHover?: (hoveredElement: any) => void;
}

const ResponsivePieChart = (props: PieChartProps) => {
  const { data, onClick, onHover, title } = props;

  const options = {
    chart: {
      type: "pie",
      height: 300,
      width: 300,
    },
    title: {
      text: title,
      // text: pieClickData ? pieClickData.id : "Sectors",
      verticalAlign: "middle",
      floating: true,
    },
    tooltip: {
      formatter(this: any) {
        const colorBox = `<span style="width:10px;height:10px;border-radius:50%;background-color:${this.color};margin-right:5px;"></span>`;

        return `<div style="font-weight: 600;font-size: 12;">${colorBox}${
          this.key
        } : ${this.y.toFixed(2)}%</div>`;
      },
    },
    plotOptions: {
      pie: {
        innerSize: "40%",
        dataLabels: {
          enabled: false,
        },
        borderColor: "none",
        slicedOffset: 8,
        borderRadius: 0,
        colors: data.map((d: any) => d.color),
        point: {
          events: {
            click(event: any) {
              onClick && onClick({ ...event.point, id: event.point.name });
            },
            mouseOver(event: any) {
              onHover && onHover({ id: event.target.name });
            },
            mouseOut() {
              onHover && onHover(null);
            },
          },
        },
      },
      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
        animation: false,
      },
    },
    series: [
      {
        name: "Share",
        data: data.map((item: any) => ({
          name: item.id,
          y: item.value,
          color: item.color,
        })),
      },
    ],
    legend: {
      enabled: true,
      align: "right",
      verticalAlign: "bottom",
      layout: "vertical",
      itemStyle: {
        color: "var(--neutral-500)",
      },
      itemHoverStyle: {
        color: "var(--black)",
      },
      symbolHeight: 15,
      symbolWidth: 15,
      symbolRadius: 2,
    },
  };

  return <GKCharts chartOptions={options} />;
};

export default ResponsivePieChart;
